/// <reference path="../../../AppKitchen/typings/AppKitchen.UI.d.ts"/>
/// <reference path="../../typings/EEX.McEc.Api.d.ts"/>

module EEX.McEc.Data.Provider {

    export class CertificateRevokeProvider extends AppKitchen.Data.Provider.ProviderBase {

        public revoke(request: McEc.Domain.CertificateRevokeRequest): JQueryPromise<Domain.RevokeCertificateResult> {
            return this.do("CertificateRevoke", request);
        }
    }
}